import { EuiFlexGroup, EuiFormLabel, EuiSelect } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { isListingActive } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const ActiveListingFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();

  const options = [
    { value: 'Active', text: formatMessage({ id: 'filters.isListingActive.active' }) },
    { value: 'Removed', text: formatMessage({ id: 'filters.isListingActive.removed' }) },
  ];

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup direction="column">
        <EuiFormLabel style={{ marginRight: '10px' }}>
          {formatMessage({ id: 'filters.isListingActive.label' })}
        </EuiFormLabel>
        <EuiSelect
          options={options}
          onChange={(x): string => isListingActive(x.target.value)}
          value={localFilters?.data?.isListingActive as unknown as string}
        />
      </EuiFlexGroup>
    </S.SidebarFilterWrapper>
  );
};
